var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('corner',{ref:"corner",attrs:{"is-loading":false,"is-management-mode":false,"publishing":_vm.publishing,"corner-listing":_vm.corner,"corner-title":_vm.cornerTitle,"resource-path":_vm.resourcePath,"resource-item-path":_vm.resourceItemPath}}),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }